function pictureFilter(_this, file, onlyImage = false) {
  let fileSuffix = file.name.substring(file.name.lastIndexOf('.') + 1)
  let _acceptSuffix = 'png'
  let acceptSuffix = 'jpg'
  let acceptSuffix2 = 'pdf'
  let acceptSuffix3 = 'docx'
  let acceptSuffix4 = 'doc'
  const isLt5m = file.size / 1024 / 1024 < 5

  // 如果 onlyImage 为 true，则只允许图片
  if (onlyImage) {
    if (fileSuffix !== _acceptSuffix && fileSuffix !== acceptSuffix) {
      _this.$notify.error({
        title: _this.$t('App.notify.title_nofity'),
        message: _this.$t('App.notify.content_jpgonly'),
      })
      return false
    }
  } else {
    // 允许图片和文档类型
    if (
      fileSuffix !== _acceptSuffix &&
      fileSuffix !== acceptSuffix &&
      fileSuffix !== acceptSuffix2 &&
      fileSuffix !== acceptSuffix3 &&
      fileSuffix !== acceptSuffix4
    ) {
      _this.$notify.error({
        title: _this.$t('App.notify.title_nofity'),
        message: _this.$t('App.notify.content_jpgonly'),
      })
      return false
    }
  }

  if (!isLt5m) {
    _this.$notify.error({
      title: _this.$t('App.notify.title_nofity'),
      message: _this.$t('App.notify.content_uploadlmt'),
    })
    return false
  }
  return true
}

function getBase64Img(img) {
  var canvas = document.createElement('canvas')
  canvas.width = img.width
  canvas.height = img.height
  var ctx = canvas.getContext('2d')
  ctx.drawImage(img, 0, 0, img.width, img.height)
  var ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase()
  var dataURL = canvas.toDataURL('image/' + ext)
  return dataURL
}

function dataURLtoBlob(base64Data) {
  var arr = base64Data.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], {
    type: mime,
  })
}

function blobToFile(blob, fileName) {
  blob.lastModifiedDate = new Date()
  blob.name = fileName
  return blob
}

function requestDingAuthCode(_this) {
  return new Promise((resolve, reject) => {
    _this.$dd.runtime.permission
      .requestAuthCode({
        corpId: 'dinged4b513e43cdbf9af2c783f7214b6d69',
        onSuccess: function (res) {
          resolve(res.code)
        },
      })
      .catch((error) => {
        resolve(null)
      })
  })
}

function setSexList(_this) {
  let sexList = []
  let female = {}
  female.value = '0'
  female.label = _this.$t('App.view.customer.label_female')
  let male = {}
  male.value = '1'
  male.label = _this.$t('App.view.customer.label_male')
  sexList.push(female)
  sexList.push(male)
  return sexList
}

function previewFile(file, freameid) {
  let frame = document.getElementById(freameid)
  if (file.file_type == 'docx' || file.file_type == 'doc') {
    frame.src = file.fileUrl
  } else if (file.file_type == 'pdf') {
    frame.src = file.fileUrl
    frame.style.display = 'block'
    frame.style.height = '30rem'
  }
}

function setProgress1(_this) {
  _this.$npg.start()
  _this.$npg.inc()

  setTimeout(() => {
    _this.$npg.done()
  }, 200)
}

function formatWorder(_this, order, saleman, e_type) {
  let orderInfo = {}
  orderInfo.id = order.fid
  orderInfo.fid = order.fid
  orderInfo.username = saleman
  orderInfo.country_id = '-'
  if (e_type === 1) {
    orderInfo.k3custid = 'GB0219'
  } else if (e_type === 2) {
    orderInfo.k3custid = 'CUST0126'
  } else {
    orderInfo.k3custid = 'GB0219'
  }

  orderInfo.orderstatus_id = '-'
  if (e_type === 1) {
    orderInfo.saleorg = 'AL'
  } else {
    orderInfo.saleorg = 'AGL'
  }

  orderInfo.delivery_terms = '-'
  orderInfo.sign = order.currency
  orderInfo.total = order.total
  orderInfo.notes = order.notes
  orderInfo.isaddedk3 = 0
  orderInfo.create_time = order.created_time

  orderInfo.custType = 1

  orderInfo.shippingaddress =
    'Address: ' +
    order.s_address_1 +
    order.s_address_2 +
    ', ' +
    order.s_city +
    ', ' +
    order.s_state +
    ', ' +
    order.b_postcode +
    ', ' +
    order.s_country +
    '| Email: ' +
    order.s_email +
    '|Tel: ' +
    order.s_phone +
    'Contacts: ' +
    order.s_firstname +
    ' ' +
    order.s_lastname
  orderInfo.receiptaddress =
    'Address: ' +
    order.b_address_1 +
    order.b_address_2 +
    ', ' +
    order.b_city +
    ', ' +
    order.b_state +
    ', ' +
    order.b_postcode +
    ', ' +
    order.b_country +
    '| Email: ' +
    order.b_email +
    '|Tel: ' +
    order.b_phone +
    'Contacts: ' +
    order.b_firstname +
    ' ' +
    order.b_lastname

  let shipping_obj = {}

  shipping_obj.country = order.s_countrycode
  shipping_obj.province = order.s_state
  shipping_obj.city = order.s_city
  shipping_obj.address = order.s_address_1 + '   ' + order.s_address_2
  shipping_obj.contacts = order.s_firstname + ' ' + order.s_lastname
  shipping_obj.zipcode = order.s_postcode
  shipping_obj.tel = order.s_phone
  shipping_obj.email = order.s_email

  let items = []
  for (let line of order.items) {
    let item = {}
    // TODO 不管，后端没有使用disprice和price
    item.disprice = line.subtotal / line.quantity
    // TODO 价格不应该等于总计
    item.price = line.subtotal
    item.product_id = line.product_k3id
    item.product_name = line.product_name
    item.quantity = line.quantity
    item.scount = line.scount
    // TODO
    item.subtotal = line.subtotal
    // item.subtotal = line.quantity * line.price
    item.subweight = 0
    items.push(item)
  }

  if (order.shippingtotal != 0) {
    let shipping = {}
    shipping.disprice = order.shippingtotal
    shipping.price = order.shippingtotal
    shipping.product_id = '06-01-001-0001-00'
    shipping.product_name = 'Shipping cost'
    shipping.quantity = 1
    shipping.scount = 0
    shipping.subtotal = order.shippingtotal
    shipping.subweight = 0
    items.push(shipping)
  }

  if (order.taxtotal != 0) {
    let tax = {}
    tax.disprice = order.taxtotal
    tax.price = order.taxtotal
    tax.product_id = '06-01-001-0007-00'
    tax.product_name = 'VAT'
    tax.quantity = 1
    tax.scount = 0
    tax.subtotal = order.taxtotal
    tax.subweight = 0
    items.push(tax)
  }

  if (order.discounttotal != 0) {
    let discount = {}
    discount.disprice = -order.discounttotal
    discount.price = -order.discounttotal
    discount.product_id = '06-01-001-0003-00'
    discount.product_name = 'Discount Fee'
    discount.quantity = -1
    discount.scount = 0
    discount.subtotal = -order.discounttotal
    discount.subweight = 0
    items.push(discount)
  }

  orderInfo.listOrderdetails = JSON.parse(JSON.stringify(items))

  orderInfo.shipping_obj = JSON.parse(JSON.stringify(shipping_obj))

  let salesuser = {}

  salesuser.k3id = _this.pageData.Userinfo.k3id
  salesuser.k3pass = _this.pageData.Userinfo.k3pass
  salesuser.k3FSalerId = _this.pageData.Userinfo.k3FSalerId

  let shippingAddress = {}
  shippingAddress.address =
    order.s_address_1 + order.s_address_2 + order.s_country
  shippingAddress.contacts = order.s_firstname + order.s_lastname

  let standardOrder = {}
  standardOrder.salesuser = JSON.parse(JSON.stringify(salesuser))
  standardOrder.order = JSON.parse(JSON.stringify(orderInfo))
  standardOrder.shippingAddress = JSON.parse(JSON.stringify(shippingAddress))

  return standardOrder
}

export {
  pictureFilter,
  getBase64Img,
  dataURLtoBlob,
  blobToFile,
  requestDingAuthCode,
  setSexList,
  previewFile,
  setProgress1,
  formatWorder,
}



// WEBPACK FOOTER //
// ./src/assets/js/utils.js